import React from 'react';
import classNames from 'classnames';
import styles from './styles.module.scss';

const ModalButtonsContainer = ({children, customClassnames = ''}) => {

  return (
    <div className={classNames(styles.container, customClassnames)}>
      {children}
    </div>
  );
};

export default ModalButtonsContainer;